import { render } from "./OrganizationInfoLayout.vue?vue&type=template&id=6a4a288e&scoped=true"
import script from "./OrganizationInfoLayout.vue?vue&type=script&lang=js"
export * from "./OrganizationInfoLayout.vue?vue&type=script&lang=js"

import "./OrganizationInfoLayout.vue?vue&type=style&index=0&id=6a4a288e&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a4a288e"]])

export default __exports__